"use client";
import React, { useEffect, useRef, useState } from "react";
import Producthunt from "./_components/Producthunt";
import { Header } from "./_components/Hero";
import CardComponent from "./_components/CardComponent";
import { featuredData } from "@/config/featured";
import BlogComponent from "./_components/BlogComponent";
import { Skeleton } from "@/components/ui/skeleton";
import { motion } from "framer-motion";
import { CardSkeleton } from "@/components/card-skeleton";
import { FeaturedOn } from "./_components/Featuredon";

type Props = {};

const Page = (props: Props) => {
  const [blogData, setBlogData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getBlogs = async () => {
    const blog = await fetch("/api/blog");
    const data = await blog.json();
    setBlogData(data);
    setLoading(false);
  };

  const [currentIndex, setCurrentIndex] = useState(0);
  const totalItems = 5; // Assuming there are 5 items, adjust as needed
  const itemWidth = 300; // Assuming each item is 300px wide, adjust as needed
  const isMounted = useRef(true);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (isMounted.current) {
  //       setCurrentIndex(prevIndex => {
  //         // If it's the last item, go back to the first item
  //         if (prevIndex === totalItems - 1) {
  //           return 0;
  //         }
  //         // Otherwise, go to the next item
  //         return prevIndex + 1;
  //       });
  //     }
  //   }, 2000); // Adjust interval time as needed

  //   return () => {
  //     isMounted.current = false;
  //     clearInterval(interval);
  //   };
  // }, []);

  // const variants = {
  //   enter: (direction: number) => {
  //     return {
  //       x: direction > 0 ? 1000 : -1000,
  //       opacity: 0,
  //     };
  //   },
  //   center: {
  //     zIndex: 1,
  //     x: 0,
  //     opacity: 1,
  //   },
  //   exit: (direction: number) => {
  //     return {
  //       zIndex: 0,
  //       x: direction < 0 ? 1000 : -1000,
  //       opacity: 0,
  //     };
  //   },
  // };

  // Calculate the x position for the motion.div
  // const xPosition = -(currentIndex * itemWidth);() => clearInterval(slideTimer);

  useEffect(() => {
    getBlogs();
  }, []);

  return (
    <>
      <Header />
      <FeaturedOn/>
      {/* <motion.div
      animate={{ x: xPosition }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
      style={{ display: 'flex', overflowX: 'hidden' }}
    >
        {featuredData.map((data, i) => (
          <div key={i} className="scroll-item">
            <CardComponent data={data} />
          </div>
        ))}
      </motion.div> */}
      <div className="w-full" data-aos="fade-up">
        <p className="flex flex-row px-10 py-px mb-4 text-lg md:text-2xl font-semibold tracking-wider text-teal-900 uppercase rounded-full bg-teal-accent-400">
         <span className="w-4 rounded-sm bg-purple-600 mr-2"></span>
          Latest Articles
        </p>
        {loading ? (
          <CardSkeleton />
        ) : (
          blogData?.map((data, i) => <BlogComponent key={i} data={data} />)
        )}
      </div>
      <div data-aos="fade-up">
        <Producthunt />
      </div>
    </>
  );
};

export default Page;
